import { useEffect, useState } from 'react'
import './Redirect.css'
import { apiFetch } from '../utils/api.js'

export default function Redirect() {
  const [message, setMessage] = useState('Processando autorização OAuth automaticamente...')

  useEffect(() => {
    let active = true

    const run = async () => {
      const params = new URLSearchParams(window.location.search)
      const error = params.get('error') || ''
      const errorDescription = params.get('error_description') || ''
      const code = params.get('code') || ''
      const state = params.get('state') || ''

      if (error) {
        const text = errorDescription || error
        if (active) setMessage(`Erro de autorização: ${text}`)
        const target = `/empresas?oauth=error&reason=${encodeURIComponent(error)}&message=${encodeURIComponent(text)}`
        window.setTimeout(() => {
          window.location.replace(target)
        }, 1200)
        return
      }

      if (!code) {
        if (active) setMessage('Authorization code ausente no retorno do OAuth.')
        const target = '/empresas?oauth=error&reason=missing_code&message=Authorization%20code%20ausente.'
        window.setTimeout(() => {
          window.location.replace(target)
        }, 1200)
        return
      }

      try {
        const callbackQuery = new URLSearchParams(window.location.search)
        const response = await apiFetch(`/api/magalu/oauth/callback?${callbackQuery.toString()}`, {
          method: 'GET',
        })

        let payload = {}
        try {
          payload = await response.json()
        } catch {
          payload = {}
        }

        if (!response.ok) {
          const reason = payload?.error || 'oauth_callback_failed'
          const text = payload?.message || 'Falha ao processar callback OAuth.'
          if (active) setMessage(`Erro de autorização: ${text}`)
          const target = `/empresas?oauth=error&reason=${encodeURIComponent(reason)}&message=${encodeURIComponent(text)}`
          window.location.replace(target)
          return
        }

        const companyId = payload?.companyId || payload?.company_id || ''
        if (active) setMessage('Autorização concluída com sucesso. Redirecionando...')
        const target = `/empresas?oauth=success${companyId ? `&companyId=${encodeURIComponent(companyId)}` : ''}${state ? `&state=${encodeURIComponent(state)}` : ''}`
        window.location.replace(target)
      } catch (requestError) {
        const text = requestError?.message || 'Erro ao processar callback OAuth.'
        if (active) setMessage(`Erro de autorização: ${text}`)
        const target = `/empresas?oauth=error&reason=callback_request_error&message=${encodeURIComponent(text)}`
        window.location.replace(target)
      }
    }

    run()
    return () => {
      active = false
    }
  }, [])

  return (
    <div className="redirect-page">
      <div className="redirect-card">
        <h1>Autorização Magalu</h1>
        <p>{message}</p>
        <p className="redirect-hint">Você será redirecionado para Empresas.</p>
      </div>
    </div>
  )
}
